import { motion } from "framer-motion";
import { WhatsAppIcon } from "./Reveal";
import { WA_MSG, wa } from "../constants/site";

export const WhatsAppFloat = () => (
    <motion.a
        href={wa(WA_MSG.trial)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        aria-label="Falar no WhatsApp"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.4, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.95 }}
        className="fixed bottom-5 right-5 z-50 flex items-center gap-2.5 rounded-full bg-[#25D366] py-4 pl-4 pr-5 text-sm font-bold text-white shadow-2xl shadow-[#25D366]/40 md:bottom-7 md:right-7"
    >
        <motion.span
            className="absolute inset-0 rounded-full bg-[#25D366]"
            animate={{ scale: [1, 1.18], opacity: [0.45, 0] }}
            transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }}
        />
        <WhatsAppIcon className="relative h-6 w-6" />
        <span className="relative hidden sm:block">Teste grátis</span>
    </motion.a>
);
